export const zhCnLocale = {
  model: {
    user: '用户'
  },
  user: {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    screenName: '名称',
    lastAccessAt: '上次登录时间',
    avatar: '头像',
    profile: '个人信息',
  }
}

export const enLocale = {
  model: {
    user: 'User'
  },
  user: {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    screenName: 'Screen name',
    lastAccessAt: 'Last access at',
    avatar: 'Avatar',
    profile: 'Profile',
  }
}

